import React, { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useState } from "react";
import { Col, Modal, Row } from "react-bootstrap";
import {
  AESDecryption,
  decryptData,
  encryptData,
  getSearchParameters,
  mobileVal,
  validateMobileNum,
} from "../CommonMethods/CommonMethods";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { Partner_Portal } from "../Configuration/API_URL";
import { toast } from "react-toastify";
import SmallLoader from "../Components/Common/smallLoader";
import axios from "axios";
import HeaderPartner from "./HeaderPartner";
import FormFooterPartner from "./FormFooterPartner";
import thumbIcon from "../../src/asset/images/partner-portal/thumbs.svg";
// import editNumber from "../asset/images/revamp-images/editImg.svg";
import PageSideBar from "./PageSideBar";
import OtpInput from "./OtpInput";

const SignupFormPartner = () => {
  const [signupLoader, setSignupLoader] = useState(false);
  const [mobError, setMobError] = useState("");
  const [mobNumber, setMobNumber] = useState("");
  const [stageResp, setStageResp] = useState("");
  const [sendOtpResp, setSendOtpResp] = useState("");
  const [modalShow, setModalShow] = useState(false);
  const [completionModal, setCompletionModal] = useState(false);
  // const [otpNum, setOtpNum] = useState("");
  const [minutes, setMinutes] = useState(0);
  const [seconds, setSeconds] = useState(30);
  const [otpSent, setOtpSent] = useState(false);
  const [fullName, setFullName] = useState();
  const [mobileNo, setMobileNo] = useState();
  const [emailId, setEmailId] = useState();
  const [utmSource, setUtmSource] = useState();
  const [source, setSource] = useState();
  const [utmMedium, setUtmMedium] = useState();
  const [utmCampaign, setUtmCampaign] = useState();
  const [otpValues, setOtpValues] = useState(Array(4).fill(""));
  const [isOtpComplete, setIsOtpComplete] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    const params = getSearchParameters();
    const requestData = params.requestdata;
    if (requestData) {
      try {
        const decryptedResp = AESDecryption(requestData);
        const validUrl = decryptedResp.split("&");
        console.log(validUrl, "validUrl");
        if (validUrl?.length > 1) {
          const fullNameUrl = validUrl[0];
          const mobileUrl = validUrl[1];
          const emailUrl = validUrl[2];
          const utmsourceUrl = validUrl[3];
          const utmmediumUrl = validUrl[4];
          const utmcampaignUrl = validUrl[5];
          const sourceUrl = validUrl[6] ? validUrl[6] : "source=partner_portal";
          const fullNameVal = fullNameUrl?.split("=")[1];
          const mobileNoVal = mobileUrl?.split("=")[1];
          const emailIdVal = emailUrl?.split("=")[1];
          const utmSourceVal = utmsourceUrl?.split("=")[1];
          const sourceVal = sourceUrl?.split("=")[1];
          const utmMediumVal = utmmediumUrl?.split("=")[1];
          const utmCampaignVal = utmcampaignUrl?.split("=")[1];
          setFullName(fullNameVal);
          setMobileNo(mobileNoVal);
          setEmailId(emailIdVal);
          setUtmSource(utmSourceVal);
          setSource(sourceVal);
          setUtmMedium(utmMediumVal);
          setUtmCampaign(utmCampaignVal);
        } else {
          console.error("Decrypted response format is incorrect");
        }
      } catch (error) {
        console.error("Decryption failed", error);
      }
    } else {
      console.log("No request data found");
      {
        // ── new path: plain UTM params directly in URL ──
        const rawSearch = window.location.search; // keeps the raw query string
        const urlParams = new URLSearchParams(rawSearch);

        const utmSourceVal = urlParams.get("utm_source") || "";
        const utmMediumVal = urlParams.get("utm_medium") || "";
        const utmCampaignVal = urlParams.get("utm_campaign") || "";
        const sourceVal = urlParams.get("source") || "";

        if (utmSourceVal || utmMediumVal || utmCampaignVal) {
          setUtmSource(utmSourceVal);
          setUtmMedium(utmMediumVal);
          setUtmCampaign(utmCampaignVal);
          setSource(sourceVal); // default source when coming via plain UTM URL

          localStorage.setItem("utmSourceUrl", utmSourceVal);
          localStorage.setItem("utmMediumUrl", utmMediumVal);
          localStorage.setItem("utmCampaignUrl", utmCampaignVal);
          localStorage.setItem("sourceUrl", sourceVal);

          console.log("Plain UTM params detected", {
            utmSourceVal,
            utmMediumVal,
            utmCampaignVal,
            sourceVal
          });
        } else {
          console.log("No request data or UTM params found");
        }
      }
    }
  }, []);

  useEffect(() => {
    localStorage.clear();
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1);
      }

      if (seconds === 0) {
        if (minutes === 0) {
          clearInterval(interval);
        } else {
          setSeconds(59);
          setMinutes(minutes - 1);
        }
      }
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, [seconds]);

  useEffect(() => {
    if (mobileNo) {
      localStorage.setItem("Mobile", mobileNo);
      if (mobileNo !== undefined || null) {
        document.getElementById("mobileInput").disabled = true;
      }
    }
    if (emailId) {
      localStorage.setItem("emailIdUrl", emailId);
    }
    if (utmSource) {
      localStorage.setItem("utmSourceUrl", utmSource);
    }
    if (source) {
      localStorage.setItem("sourceUrl", source);
    }
    if (utmMedium) {
      localStorage.setItem("utmMediumUrl", utmMedium);
    }
    if (utmCampaign) {
      localStorage.setItem("utmCampaignUrl", utmCampaign);
    }
    if (fullName) {
      localStorage.setItem("fullName", fullName);
    }
  }, [mobileNo]);

  const initFacebookPixel = () => {
    if (window.fbq) {
      window.fbq("track", "Contact");
    } else {
      (function (f, b, e, v, n, t, s) {
        if (f.fbq) return;
        n = f.fbq = function () {
          n.callMethod
            ? n.callMethod.apply(n, arguments)
            : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = true;
        n.version = "2.0";
        n.queue = [];
        t = b.createElement(e);
        t.async = true;
        t.src = v;
        s = b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t, s);
      })(
        window,
        document,
        "script",
        "https://connect.facebook.net/en_US/fbevents.js",
      );

      // Replace with your actual Facebook Pixel ID
      window.fbq("init", "2462375333984919");
      window.fbq("track", "Contact");
    }
  };

  const OtpSchema = Yup.object().shape({
    otp1: Yup.string().required(),
    otp2: Yup.string().required(),
    otp3: Yup.string().required(),
    otp4: Yup.string().required(),
  });

  // const mobileNoUrl = localStorage.getItem("mobileNoUrl");
  // const utmSourceUrl = localStorage.getItem("utmSourceUrl");
  // const utmMediumUrl = localStorage.getItem("utmMediumUrl");
  // const utmCampaignUrl = localStorage.getItem("utmCampaignUrl");

  const {
    register: mobileOtpRegister,
    getValues: getMobileOtpValue,
    reset: mobileOtpReset,
  } = useForm({
    mode: "onChange",
    resolver: yupResolver(OtpSchema),
  });

  const handleSubmit = (e) => {
    e.preventDefault();

    if (mobNumber?.length === 10 || mobileNo !== undefined || null) {
      initFacebookPixel();
      sendOtp();
    } else if (mobNumber?.length === 0 || mobileNo !== undefined || null) {
      setMobError("Enter Mobile Number");
    } else if (mobNumber?.length !== 10 || mobileNo !== undefined || null) {
      setMobError("Enter correct mobile number");
    }
  };

  const checkMobile = (e) => {
    const onlyNumbers = e.target.value.replace(/\D/g, "").slice(0, 10);
    setMobNumber(onlyNumbers);
    localStorage.setItem("Mobile", onlyNumbers);
    setMobError("");

    if (onlyNumbers.length > 0) {
      if (validateMobileNum(onlyNumbers)) {
        setMobError("");
      } else {
        setMobError(
          "Please enter valid number, Initial digit must range from 6-9",
        );
      }
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      sendOtp();
    }
  };

  const sendOtp = async () => {
    setSignupLoader(true);
    let encryptedPayload = {
      mobile: mobileNo !== undefined || null ? mobileNo : mobNumber,
    };
    let encPayloadVal = encryptData(JSON.stringify(encryptedPayload));
    try {
      const getValue = await axios.post(
        Partner_Portal.GetSendOtp_Url,
        encPayloadVal,

        {
          headers: {
            "Content-Type": "text/plain",
          },
        },
      );
      const responseData = decryptData(getValue?.data);
      const responseValue = JSON.parse(responseData);
      console.log(responseValue, "responseValue");

      if (responseValue?.status === 0) {
        setOtpSent(true);
        document.getElementById("mobileInput").disabled = true;

        setMinutes(0);
        setSeconds(30);
        // setOtpModal(true);
        setOtpValues(Array(4)?.fill(""));
        setSendOtpResp(responseValue?.data?.message);
        // mobileOtpReset();
      } else if (responseValue?.status === 1) {
        // setOtpModal(false);
        toast.error(responseValue?.message);
      }
    } catch (error) {
      console.log(error);
      if (error?.response?.status === 500) {
        toast.error(
          "Your application couldn’t be processed due to a technical issue. Please try again.",
        );
      }
      if (error?.request?.status === 401) {
        localStorage.clear("");
        navigate("/partner");
      }
    } finally {
      setSignupLoader(false);
    }
  };

  const validateOtp = async (values) => {
    // const { otp1, otp2, otp3, otp4 } = values;
    const otpString = otpValues?.join("");
    let encryptedPayload = {
      mobile: mobileNo !== undefined || null ? mobileNo : mobNumber,
      // otp: `${otp1}${otp2}${otp3}${otp4}`,
      otp: otpString,
    };
    let encPayloadVal = encryptData(JSON.stringify(encryptedPayload));

    try {
      const getValue = await axios.post(
        Partner_Portal.GetVerifyOtp_Url,
        encPayloadVal,

        {
          headers: {
            "Content-Type": "text/plain",
          },
        },
      );
      const validateResp = decryptData(getValue?.data);
      const otpResponse = JSON.parse(validateResp);

      if (otpResponse?.status === 0) {
        let storeToken = otpResponse?.data?.info?.token;
        localStorage.setItem("partner_signup_token", storeToken);
        if (
          (utmSource !== undefined || null) &&
          (utmCampaign !== undefined || null) &&
          (utmMedium !== undefined || null)
        ) {
          getLeadDetails();
        }
        getSignupPartnerDetail();
      } else {
        toast.error(otpResponse?.message);
        setOtpValues(Array(4)?.fill(""));
        setTimeout(() => {
          const firstInput = document.getElementById("otp-input-0");
          if (firstInput) firstInput.focus();
        }, 0);
        // mobileOtpReset();
      }
    } catch (error) {
      console.log(error);
      if (error?.response?.status === 500) {
        toast.error(
          "Your application couldn’t be processed due to a technical issue. Please try again.",
        );
      }
      if (error?.request?.status === 401) {
        localStorage.clear("");
        navigate("/partner");
      }
    }
  };

  const getLeadDetails = async () => {
    setSignupLoader(true);
    let encryptedPayload = {
      utm_source: utmSource,
      utm_campaign: utmCampaign,
      utm_medium: utmMedium,
      source: source,
    };
    let encPayloadVal = encryptData(JSON.stringify(encryptedPayload));
    try {
      const getValue = await axios.post(
        Partner_Portal.GetLead_Url,
        encPayloadVal,

        {
          headers: {
            "Content-Type": "text/plain",
            Authorization: `Bearer ${localStorage.getItem(
              "partner_signup_token",
            )}`,
          },
        },
      );
      const leadDetails = decryptData(getValue?.data);
      const decryptedLead = JSON.parse(leadDetails);

      if (decryptedLead?.status === 0) {
        // toast.success(decryptedLead?.data?.message);
      } else if (decryptedLead?.status === 1) {
        toast.error(decryptedLead?.message);
      }
    } catch (error) {
      console.log(error);
      toast.error("Something went wrong.");
    } finally {
      setSignupLoader(false);
    }
  };

  const getSignupPartnerDetail = async () => {
    try {
      const getValues = await axios.get(
        Partner_Portal.CreatePartner_Url,

        {
          headers: {
            "Content-Type": "text/plain",
            Authorization: `Bearer ${localStorage.getItem(
              "partner_signup_token",
            )}`,
          },
        },
      );
      const signupResp = decryptData(getValues?.data);
      const decryptedResp = JSON.parse(signupResp);
      if (decryptedResp?.status === 0) {
        let partnerData = decryptedResp?.data?.info;

        getStageData();
      } else if (decryptedResp?.status === 1) {
        navigate("/partner/basic-details");
        if (stageResp) {
          toast.error(decryptedResp?.message);
        }
      }
    } catch (error) {
      console.log(error);
      toast.error("Something went wrong.");
    }
  };

  function otpBtn() {
    sendOtp();
  }

  const handleVerifyData = () => {
    // let otpInput = getMobileOtpValue();
    // const { otp1, otp2, otp3, otp4 } = otpInput;

    // if (otp1 && otp2 && otp3 && otp4) {
    //   validateOtp(otpInput);
    //   getMobileOtpValue("");
    // }

    if (otpValues?.length === 4) {
      validateOtp();
      // setOtpValues(Array(4).fill(""));
    } else {
      toast.error("Please enter valid OTP");
    }
  };

  const completeModal = () => {
    setCompletionModal(false);
    window.location.replace("https://cosmos.bajajfinservsecurities.in/");
  };

  const getStageData = async () => {
    // setLoader(true);
    try {
      const getValue = await axios.get(
        Partner_Portal.GetResume_Url,

        {
          headers: {
            "Content-Type": "text/plain",
            Authorization: `Bearer ${localStorage.getItem(
              "partner_signup_token",
            )}`,
          },
        },
      );
      const getStageDetails = decryptData(getValue?.data);
      const decryptedStageData = JSON.parse(getStageDetails);
      console.log(decryptedStageData, "decryptedStageData");

      if (decryptedStageData?.status === 0) {
        const stageValue = decryptedStageData?.data?.info;
        let stages = JSON.stringify(stageValue);
        localStorage.setItem("resumeDetails", stages);
        checkStages(stageValue?.status);
        setStageResp(stageValue);

        console.log(stageValue, "decryptedStage");
        if (stageValue?.bankDetailsFilled === false) {
          localStorage.setItem("showBankData", true);
        }
      } else {
        toast.error(decryptedStageData?.message);
      }
    } catch (error) {
      console.log(error);
      if (error?.response?.status === 500) {
        toast.error(
          "Your application couldn’t be processed due to a technical issue. Please try again.",
        );
      }
      if (error?.request?.status === 401) {
        localStorage.clear("");
        navigate("/partner");
      }
    } finally {
      // setLoader(false);
    }
  };

  const checkStages = (checkStatusId) => {
    const checkStage = localStorage.getItem("resumeDetails");
    localStorage.setItem("statusId", checkStatusId);

    const basicPanIncomplete =
      (JSON.parse(checkStage).basicDetailsFilled === false &&
        JSON.parse(checkStage).panDocumentFilled === true) ||
      (JSON.parse(checkStage).basicDetailsFilled === true &&
        JSON.parse(checkStage).panDocumentFilled === false);

    if (
      basicPanIncomplete &&
      JSON.parse(checkStage)?.unlockDigilockerFilled === false &&
      (checkStatusId === 0 || checkStatusId === -2)
    ) {
      localStorage.setItem("incompletePan", "true");
      navigate("/partner/document-upload");
      return;
    }

    const panComplete =
      JSON.parse(checkStage).basicDetailsFilled === true &&
      JSON.parse(checkStage).panDocumentFilled === true;
    const addressIncomplete =
      panComplete &&
      (JSON.parse(checkStage).addressDetailsFilled === false ||
        JSON.parse(checkStage).addressProofFilled === false || // front Aadhar
        JSON.parse(checkStage).addressDocumentFilled === false); // Back Aadhar

    if (
      addressIncomplete &&
      JSON.parse(checkStage)?.unlockDigilockerFilled === false &&
      (checkStatusId === 0 || checkStatusId === -2)
    ) {
      localStorage.setItem("incompleteAddress", "true");
      navigate("/partner/document-upload");
      return; // exit early
    }

    if (
      JSON.parse(checkStage)?.emailOtpVerified === false &&
      (checkStatusId === 0 || checkStatusId === -2)
    ) {
      navigate("/partner/basic-details");
    } else if (
      JSON.parse(checkStage)?.unlockDigilockerFilled === false &&
      (JSON.parse(checkStage)?.basicDetailsFilled === false ||
        JSON.parse(checkStage)?.panDocumentFilled === false ||
        JSON.parse(checkStage)?.addressDetailsFilled === false ||
        JSON.parse(checkStage)?.addressProofFilled === false ||
        JSON.parse(checkStage).addressDocumentFilled === false) &&
      (checkStatusId === 0 || checkStatusId === -2)
    ) {
      navigate("/partner/document-upload");
    } else if (
      ((JSON.parse(checkStage)?.bankDetailsFilled === false &&
        // JSON.parse(checkStage)?.impsValidated === false &&
        JSON.parse(checkStage)?.bankProofFilled === false) ||
        (JSON.parse(checkStage)?.bankDetailsFilled === false &&
          // JSON.parse(checkStage)?.impsValidated === false &&
          JSON.parse(checkStage)?.bankProofFilled === true) ||
        (JSON.parse(checkStage)?.bankDetailsFilled === true &&
          // JSON.parse(checkStage)?.impsValidated === false &&
          JSON.parse(checkStage)?.bankProofFilled === false)) &&
      (checkStatusId === 0 || checkStatusId === -2)
    ) {
      navigate("/partner/bank-details");
    } else if (
      JSON.parse(checkStage)?.unlockDigilockerFilled === false &&
      JSON.parse(checkStage)?.uploadPhotoFilled === false &&
      (checkStatusId === 0 || checkStatusId === -2)
      // ||
      // (
      // JSON.parse(checkStage)?.uploadPhotoFilled === true &&
      // (checkStatusId === 0 || checkStatusId === -2))
    ) {
      navigate("/partner/selfie-upload");
    } else if (
      (JSON.parse(checkStage)?.panDocumentFilled === true &&
        JSON.parse(checkStage)?.addressProofFilled === true &&
        JSON.parse(checkStage).addressDocumentFilled === true &&
        JSON.parse(checkStage)?.addressDocumentFilled === true &&
        ((JSON.parse(checkStage)?.impsValidated === true &&
          JSON.parse(checkStage)?.bankProofFilled === false) ||
          (JSON.parse(checkStage)?.impsValidated === false &&
            JSON.parse(checkStage)?.bankProofFilled === true)) &&
        JSON.parse(checkStage)?.uploadPhotoFilled === true &&
        checkStatusId === 1) ||
      (checkStatusId === 2 &&
        JSON.parse(checkStage)?.esignAgrtDownload === true &&
        JSON.parse(checkStage)?.esignAgrtGenerated === true)
      // && JSON.parse(checkStage)?.paymentComplete === true
    ) {
      setModalShow(true);
    } else if (checkStatusId === 2) {
      navigate("/partner/e-sign");
    } else if (checkStatusId === 3) {
      setCompletionModal(true);
    }
  };

  const handleMobNumber = () => {
    setOtpSent(false);
    document.getElementById("mobileInput").disabled = false;
    document.getElementById("mobileInput").focus();
  };

  const handleOtpComplete = (status) => {
    setIsOtpComplete(status);
  };

  const handleOk = () => {
    setModalShow(false);
    window.location.replace("/partner");
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pastedData = e.clipboardData.getData("Text");
    const onlyNumbers = pastedData.replace(/\D/g, "").slice(0, 10);

    if (onlyNumbers && /^[6-9]/.test(onlyNumbers)) {
      setMobNumber(onlyNumbers);
      localStorage.setItem("Mobile", onlyNumbers);
      setMobError("");
    } else {
      setMobError(
        "Please enter valid number, Initial digit must range from 6-9",
      );
    }
  };

  return (
    <>
      <HeaderPartner />

      <main className="main-content page-wrapper partner-page signup-page">
        <div className="h-md-100 ">
          <Row className="h-md-100 p-0 m-0 mobile-view">
            <Col lg={6} className="p-0">
              <PageSideBar />
            </Col>
            <Col lg={6} className="p-0">
              <div className="page-header right-box">
                <div className="wrap-all">
                  <div className="page-left landing-page viewheight">
                    <div>
                      <h2 className="page-title">
                        Create your own success story
                      </h2>
                      <h3 className="page-subtitle partner-subtitle">
                        Welcome to the first step of your new initiative!
                      </h3>
                    </div>
                  </div>
                  <div>
                    <label className="text-label">
                      Enter Mobile Number<span class="mandatory-label">*</span>
                    </label>
                    <div>
                      <div className="mt-2 mobile-wrapper number-wrapper">
                        <p className="mob-code">+91</p>
                        <input
                          type="text"
                          id="mobileInput"
                          className="form-control has-value is-invalid partner-mob mob-input"
                          maxLength={10}
                          placeholder="Enter your mobile number"
                          autoComplete="off"
                          value={mobNumber || mobileNo || ""}
                          onPaste={handlePaste}
                          onKeyPress={(e) => {
                            mobileVal(e);
                            handleKeyPress(e);
                          }}
                          onChange={checkMobile}
                        />
                      </div>

                      {mobError ? (
                        <p className="forget-link">
                          <span>{mobError}</span>
                        </p>
                      ) : (
                        ""
                      )}

                      {/* </div> */}
                    </div>
                  </div>
                  {sendOtpResp?.length !== 0 && otpSent === true ? (
                    // <div className="otp-wrapper">
                    //   <div className="wrap-otp-content">
                    //     <p className="otp-enter">Enter OTP</p>
                    //     <p className="otp-enter">
                    //       <div className="countdown-text">
                    //         <div
                    //           className="btn-text-wrap"
                    //           disabled={seconds > 0 || minutes > 0}
                    //           style={{
                    //             color:
                    //               seconds > 0 || minutes > 0
                    //                 ? "#92929291"
                    //                 : "rgba(49, 49, 49, 1)",
                    //           }}
                    //         >
                    //           <button
                    //             className="btn-resend"
                    //             disabled={seconds > 0 || minutes > 0}
                    //             style={{
                    //               color:
                    //                 seconds > 0 || minutes > 0
                    //                   ? "#92929291"
                    //                   : "#0069B4",
                    //             }}
                    //             onClick={otpBtn}
                    //           >
                    //             Resend OTP
                    //           </button>
                    //           <p className="otpnumber">in</p>
                    //         </div>
                    //         {seconds > 0 || minutes > 0 ? (
                    //           <p>
                    //             {minutes < 10 ? `0${minutes}` : minutes}:
                    //             {seconds < 10 ? `0${seconds}` : seconds}
                    //           </p>
                    //         ) : (
                    //           <p className="otpnumber">00:00</p>
                    //         )}
                    //       </div>
                    //       {/* <OtpTimer resendOtp={otpBtn} /> */}
                    //     </p>
                    //   </div>
                    //   <div>
                    //     <form
                    //       id="otp-form"
                    //       className="flex-col"
                    //       autoComplete="off"
                    //     >
                    //       <div className="form-group">
                    //         <input
                    //           type="text"
                    //           minLength="1"
                    //           maxLength="1"
                    //           name="otp1"
                    //           autoFocus={true}
                    //           onInput={(e) => {
                    //             MobileOtpInput(e);
                    //           }}
                    //           onKeyUp={(e) => handleOtp(e, 1)}
                    //           className="otp-form-control"
                    //           pattern="[0-9]*"
                    //           inputMode="numeric"
                    //           {...mobileOtpRegister("otp1")}
                    //           onKeyPress={(e) => handleKeyOtp(e)}
                    //         />
                    //         <input
                    //           type="text"
                    //           minLength="1"
                    //           maxLength="1"
                    //           id="firstOtp"
                    //           onInput={(e) => {
                    //             MobileOtpInput(e);
                    //           }}
                    //           onKeyUp={(e) => handleOtp(e, 2)}
                    //           name="otp2"
                    //           pattern="[0-9]*"
                    //           inputMode="numeric"
                    //           className="otp-form-control"
                    //           {...mobileOtpRegister("otp2")}
                    //           onKeyPress={(e) => handleKeyOtp(e)}
                    //         />
                    //         <input
                    //           type="text"
                    //           minLength="1"
                    //           maxLength="1"
                    //           name="otp3"
                    //           pattern="[0-9]*"
                    //           inputMode="numeric"
                    //           className="otp-form-control"
                    //           onInput={(e) => {
                    //             MobileOtpInput(e);
                    //           }}
                    //           onKeyUp={(e) => handleOtp(e, 3)}
                    //           {...mobileOtpRegister("otp3")}
                    //           onKeyPress={(e) => handleKeyOtp(e)}
                    //         />
                    //         <input
                    //           type="text"
                    //           minLength="1"
                    //           maxLength="1"
                    //           name="otp4"
                    //           pattern="[0-9]*"
                    //           inputMode="numeric"
                    //           className="otp-form-control"
                    //           onInput={(e) => {
                    //             MobileOtpInput(e);
                    //           }}
                    //           onKeyUp={(e) => handleOtp(e, 4)}
                    //           {...mobileOtpRegister("otp4")}
                    //           onKeyPress={(e) => handleKeyOtp(e)}
                    //         />
                    //       </div>
                    //     </form>
                    //     {/* <OtpTimer resendOtp={otpBtn} /> */}
                    //   </div>

                    //   <div className="otpsent-content">
                    //     <p>
                    //       OTP sent to{" "}
                    //       <p className="number">
                    //         +91 {(mobileNo !== undefined || null) ? mobileNo : mobNumber}
                    //       </p>
                    //       {mobileNo == null ? (
                    //         <div
                    //           className="wrap-edit"
                    //           onClick={handleMobNumber}
                    //         >
                    //           <img
                    //           alt="edit icon"
                    //             className="edit-number"
                    //             src={editNumber}
                    //           />

                    //           <p className="edit-number">Edit</p>
                    //         </div>
                    //       ) : (
                    //         ""
                    //       )}
                    //     </p>
                    //   </div>
                    // </div>
                    <OtpInput
                      otpValues={otpValues}
                      setOtpValues={setOtpValues}
                      onVerify={handleVerifyData}
                      otpBtn={otpBtn}
                      seconds={seconds}
                      minutes={minutes}
                      onOtpComplete={handleOtpComplete}
                      mobileNo={mobileNo}
                      mobNumber={mobNumber}
                      handleMobNumber={handleMobNumber}
                    />
                  ) : (
                    ""
                  )}

                  <div>
                    {otpSent &&
                    (mobNumber?.length === 10 ||
                      mobileNo !== undefined ||
                      null) ? (
                      <button
                        className={`partner-loginBtn ${isOtpComplete ? "" : "disable-esign-btn"}`}
                        type="submit"
                        disabled={!isOtpComplete}
                        onClick={isOtpComplete ? handleVerifyData : undefined}
                      >
                        {signupLoader ? <SmallLoader /> : "VERIFY"}
                      </button>
                    ) : (
                      <button
                        className={`partner-loginBtn ${mobNumber?.length === 10 || mobileNo?.length === 10 ? "" : "disable-esign-btn"}`}
                        type="submit"
                        disabled={
                          !(mobNumber?.length === 10 || mobileNo?.length === 10)
                        }
                        onClick={
                          mobNumber?.length === 10 || mobileNo?.length === 10
                            ? handleSubmit
                            : undefined
                        }
                      >
                        {signupLoader ? <SmallLoader /> : "GET OTP"}
                      </button>
                    )}
                  </div>
                </div>
                <div className="wrap-footerData">
                  <FormFooterPartner />
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </main>

      <div className="congo-modal">
        <Modal
          show={modalShow}
          // onHide={onHide}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          className="ifscModal confirmation-modal application-submit"
          backdrop="static"
          keyboard={false}
        >
          <Modal.Body>
            <img
              className="thumb-img submit-thumbImg"
              src={thumbIcon}
              alt="thumb icon"
            />
            <form className="modal-form select-new">
              <div className="form-group submiApp">
                <span>
                  Your Application submitted successfully! Once verification is
                  complete, you will get notified on your registered mobile
                  number and email id.
                </span>
              </div>
            </form>

            <div className="text-center confirmation-button">
              <button
                className="common-btn conf-btn submit-app-btn"
                type="button"
                onClick={handleOk}
              >
                Okay
              </button>
            </div>
          </Modal.Body>
        </Modal>
      </div>

      <div className="congo-modal">
        <Modal
          show={completionModal}
          // onHide={onHide}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          className="ifscModal confirmation-modal application-submit"
          backdrop="static"
          keyboard={false}
        >
          <Modal.Body>
            <img
              className="thumb-img submit-thumbImg"
              src={thumbIcon}
              alt="thumb icon"
            />
            <form className="modal-form select-new">
              <div className="form-group submiApp">
                <span>
                  Your Application Completed successfully! Now you can login
                  with the user id and password via COSMOS application.
                </span>
              </div>
            </form>

            <div className="text-center confirmation-button">
              <button
                className="common-btn conf-btn submit-app-btn"
                type="submit"
                onClick={() => completeModal()}
              >
                Okay
              </button>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    </>
  );
};

export default SignupFormPartner;
